import React, { useContext } from 'react';
import { ThemeContext } from '../../context';

const ThemeToggle = () => {
  const { state, dispatch } = useContext(ThemeContext);

  const toggleDark = () => {
    dispatch({ type: 'TOGGLE_DARK' });
  };

  return (
    <div className="fixed right-4 top-4 z-50">
      <button
        onClick={toggleDark}
        className="px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 shadow-sm hover:shadow-md transition-all duration-200 text-sm font-medium hover:scale-105"
        aria-label="Toggle dark mode"
      >
        {state.darkMode ? '☀️ Light' : '🌙 Dark'}
      </button>
    </div>
  );
};

export default ThemeToggle;
